import { combineReducers } from 'redux';
import auth, { initialState as authInitialState } from './auth/reducer';
import user, { initialState as userInitialState } from './user/reducer';
import audioPlayer, {
  initialState as audioPlayerInitialState,
} from './audioPlayer/reducer';
import noti, { initialState as notiInitialState } from './noti/reducer';
import dialog, { initialState as dialogInitialState } from './dialog/reducer';
import request, { initialState as requestInitState } from './request/reducer';
import synthesisRequest, {
  initialState as synthesisRequestInitState,
} from './synthesisRequest/reducer';
import voucher, {
  initialState as voucherInitialState,
} from './voucher/reducer';
import banner, { initialState as bannerInitialState } from './banner/reducer';
import language, {
  initialState as languageInitialState,
} from './language/reducer';
import voice, { initialState as voiceInitialState } from './voice/reducer';
import device, { initialState as deviceInitialState } from './device/reducer';
import deviceV2, {
  initialState as deviceV2InitialState,
} from './deviceV2/reducer';
import configTable, {
  initialState as configTableInitialState,
} from './configTable/reducer';
import dubbingRequest, {
  initialState as dubbingRequestInitState,
} from './dubbingRequest/reducer';
import layout, { initialState as layoutInitState } from './layout/reducer';
import audioPreview, {
  initialState as audioPreviewInitState,
} from './audioPreview/reducer';
import order, { initialState as orderState } from './order/reducer';
import category, { initialState as categoryState } from './category/reducer';
import audioVoiceCloning, {
  initialState as audioVoiceCloningState,
} from './audioVoiceCloning/reducer';
import province, { initialState as provinceState } from './province/reducer';
import voiceVoiceCloning, {
  initialState as voiceVoiceCloningState,
} from './voiceVoiceCloning/reducer';
import location, {
  initialState as locationInitialState,
} from './location/reducer';
import dictionary, {
  initialState as dictionaryInitialState,
} from './dictionary/reducer';
import limitedFeaturesDialog, {
  initialState as limitedFeaturesDialogInitialState,
} from './limitedFeaturesDialog/reducer';
import packageReducer, {
  initialState as packageInitialState,
} from './package/reducer';
import project, {
  initialState as projectInitialState,
} from './project/reducer';
import instantVoiceTraining, {
  initialState as instantVoiceTrainingInitialState,
} from './instantVoiceTraining/reducer';
import referralConfig, {
  initialState as referralConfigInitialState,
} from './referralConfig/reducers';
import audioVoiceLibrary, {
  initialState as audioVoiceLibraryInitialState,
} from './audioVoiceLibrary/reducer';
import cancelReasonDialog, {
  initialState as cancelReasonDialogInitialState,
} from './cancelReasonDialog/reducer';
import onboardingPopup, {
  initialState as onboardingPopupInitialState,
} from './onboardingPopup/reducer';
import educatorsSurvey, {
  initialState as educatorsSurveyInitialState,
} from './educatorsSurvey/reducer';
import pronunciationCheck, {
  initialState as pronunciationCheckInitialState,
} from './pronunciationCheck/reducer';
import notification, {
  initialState as notificationInitialState,
} from './notification/reducer';
import history, {
  initialState as historyInitialState,
} from './history/reducer';

export const initialState = {
  auth: authInitialState,
  user: userInitialState,
  audioPlayer: audioPlayerInitialState,
  noti: notiInitialState,
  dialog: dialogInitialState,
  request: requestInitState,
  synthesisRequest: synthesisRequestInitState,
  voucher: voucherInitialState,
  banner: bannerInitialState,
  language: languageInitialState,
  voice: voiceInitialState,
  device: deviceInitialState,
  deviceV2: deviceV2InitialState,
  configTable: configTableInitialState,
  dubbingRequest: dubbingRequestInitState,
  layout: layoutInitState,
  audioPreview: audioPreviewInitState,
  order: orderState,
  category: categoryState,
  audioVoiceCloning: audioVoiceCloningState,
  province: provinceState,
  voiceVoiceCloning: voiceVoiceCloningState,
  location: locationInitialState,
  dictionary: dictionaryInitialState,
  limitedFeaturesDialog: limitedFeaturesDialogInitialState,
  package: packageInitialState,
  project: projectInitialState,
  instantVoiceTraining: instantVoiceTrainingInitialState,
  referralConfig: referralConfigInitialState,
  audioVoiceLibrary: audioVoiceLibraryInitialState,
  cancelReasonDialog: cancelReasonDialogInitialState,
  onboardingPopup: onboardingPopupInitialState,
  educatorsSurvey: educatorsSurveyInitialState,
  pronunciationCheck: pronunciationCheckInitialState,
  notification: notificationInitialState,
  history: historyInitialState,
};

export default combineReducers({
  auth,
  user,
  audioPlayer,
  noti,
  dialog,
  request,
  synthesisRequest,
  voucher,
  banner,
  language,
  voice,
  device,
  deviceV2,
  configTable,
  dubbingRequest,
  layout,
  audioPreview,
  order,
  category,
  audioVoiceCloning,
  province,
  voiceVoiceCloning,
  location,
  dictionary,
  limitedFeaturesDialog,
  packages: packageReducer,
  project,
  instantVoiceTraining,
  referralConfig,
  audioVoiceLibrary,
  cancelReasonDialog,
  onboardingPopup,
  educatorsSurvey,
  pronunciationCheck,
  notification,
  history,
});
